import { AppNameFireBase, UserTypeName, UserType, ActionTypeFireBase } from '@/common/constant.ts'
import loadScript from 'load-script'
import { getEnvConfig } from '@/utils/env-variables'

var _isInfo
window._isInfo = _isInfo || {}

export const collectDataISMAC = (data) => {
  const ISMACConfig = getEnvConfig('ISMACConfig') || {}
  window._isInfo._appid = data.appId // ApplicationCode: do iSMAC cung cấp
  window._isInfo._appver = data.appVer // ApplicationVersion: Phiên bản ứng dụng
  window._isInfo._uuid = data.uuId //= ApplicationCode + CompanyCode + EmployeeCode
  window._isInfo._viewname = data.viewName// Tên màn hình hiện tại
  window._isInfo._packcode = data.appId// ProductPackCode: Tên gói sản phẩm
  loadScript(ISMACConfig.serviceUri)
}

const Analytics = {
  analytics: null,
  isInitDone: false,

  /* Khởi tạo Analytics */
  init: function () {
    // Your web app's Firebase configuration
    const me = this
    try {
      // Your web app's Firebase configuration
      // For Firebase JS SDK v7.20.0 and later, measurementId is optional
      const firebaseConfig = {
        apiKey: 'AIzaSyB75QW9a3rXBc9Os67iNSx1V9w_1uovCH0',
        authDomain: 'qlth-sisap.firebaseapp.com',
        databaseURL: 'https://qlth-sisap.firebaseio.com',
        projectId: 'qlth-sisap',
        storageBucket: 'qlth-sisap.appspot.com',
        messagingSenderId: '283693565694',
        appId: '1:283693565694:web:8a3701c62fb304aa7e87af',
        measurementId: 'G-W44RDQK9V9'
      }
      window.firebase.initializeApp(firebaseConfig)
      // Initialize Firebase
      me.analytics = window.firebase.analytics()
      me.analytics.setUserProperties({
        AppName: AppNameFireBase.HomeWork,
        UserType: window.__contextData.UserType === UserType.Teacher ? UserTypeName.Teacher : UserTypeName.Student
      })
    } catch (e) {
      me.isInitDone = false
      console.log(e)
    }
  },

  /**
   * Gửi dữ liệu lên fire base phục vụ monitor
   * @param {string} groupType: Nghiệp vụ chính cần ghi log (Kế hoạch thu, Quản lý thu, Tổng kết,...)
   * @param {string} businessType: Nghiệp vụ chi tiết của nghiệp vụ chính (Đăng ký khoản thu, đợt thu,...)
   * HNTHANG 22.09.2020 Update event name
   */
  logDataFireBase: function (groupType, businessType, actionType) {
    try {
      const me = this
      if (!me.isInitDone) {
        me.isInitDone = true
        me.init()
      }
      const appName = AppNameFireBase.HomeWork
      const schoolType = 'Cấp trường'
      const logData = {
        AppName: appName,
        SchoolName: window.__contextData.OrganizationName,
        SchoolLevel: window.__contextData.SchoolLevel, // Cấp đơn vị đang đăng nhập
        SchoolType: schoolType, // Tên các cấp đơn vị đang đăng nhập: "Sở GD, Phòng GD, THPT, THCS, Tiểu học, Mầm non, Liên cấp"
        OrganizationID: window.__contextData.OrganizationID || window.__contextData.UserID,
        UserID: window.__contextData.UserID,
        UserName: window.__contextData.FullName,
        UserType: window.__contextData.UserType === UserType.Teacher ? UserTypeName.Teacher : UserTypeName.Student,
        GroupType: groupType,
        BusinessType: businessType,
        ActionType: actionType || ActionTypeFireBase.View,
        Version: window.__env ? window.__env.version : ''
      }
      // console.log(appName + ' | ' + groupType + ' | ' + businessType)
      me.analytics.logEvent(appName + ' | ' + groupType + ' | ' + businessType, logData)
    } catch (e) {
    }
  },

  resource: {
    /** Log các nghiệp vụ chính */
    GroupType: {
      DashBoard: 'Thống kê',
      Teaching: 'Giảng dạy',
      DocumentStore: 'Kho học liệu',
      System: 'Hệ thống',
      Learning: 'Học tập',
      DocumentTest: 'Kiểm tra',
      RoomEMIS: 'Phòng học trực tuyến',
      AssessmentPeriod: 'Kỳ đánh giá',
      SelfLearning: 'Tự học',
      Exam: 'Đề thi'

    },

    /** Log các nghiệp vụ chi tiết theo luồng nghiệp vụ chính */
    BusinessType: {
      DashBoard_OverView: 'Thống kê',
      DashBoard_Detail: 'Thống kê chi tiết',
      DashBoard_StudentHardWorkingDesktop: 'Vinh danh học sinh chăm chỉ',
      DashBoard_EvaluateIndividualHeader: 'Đánh giá học tập cá nhân',

      Teaching_Classroom: 'Danh sách lớp học',
      Teaching_Student: 'Danh sách học sinh của lớp học',
      Teaching_Teacher: 'Danh sách giáo viên của lớp học',
      Teaching_ExcerciseCard: 'Danh sách bài tập của lớp học',
      Teaching_ExcerciseDetail: 'Xem chi tiết bài tập của lớp học',
      Teaching_GiveExcercise: 'Giao bài tập',
      Teaching_AddClass: 'Tạo lớp học thêm',
      Teaching_FormalClass: 'Tham gia lớp học chính quy',
      Teaching_MarkExcercise: 'Chấm bài',

      DocumentStore_List: 'Danh sách học liệu',
      DocumentStore_List_Mine: 'Học liệu của tôi',
      DocumentStore_List_ShareSchool: 'Học liệu chia sẻ trong trường',
      DocumentStore_List_Refer: 'Học liệu tham khảo',
      DocumentStore_List_Share: 'Học liệu chia sẻ của tôi',
      DocumentStore_Game: 'Tạo trò chơi',

      DocumentStore_Prepare: 'Soạn học liệu',
      DocumentStore_TryLearning: 'Làm thử học liệu',
      DocumentStore_QuickFix: 'Sửa nhanh học liệu',
      DocumentStore_Detail: 'Xem chi tiết học liệu',

      Learning_Classroom: 'Danh sách lớp học',
      Learning_Excercise: 'Danh sách bài tập ',
      Learning_ExcerciseRefer: 'Danh sách bài tập tham khảo',
      Learning_ClassApprove: 'Danh sách lớp chờ phê duyệt',
      Learning_ClassApproveDetail: 'Xem chi tiết lớp học chờ phê duyệt',
      Learning_JoinClass: 'Tham gia lớp học',
      Learning_Classmate: 'Danh sách bạn học',
      Learning_ExcerciseDetail: 'Danh sách bài tập chi tiết',
      Learning_DoExcercise: 'Tiến hành làm bài',
      Learning_ViewAnswerExcercise: 'Xem bài chữa',
      Learning_PlayGame: 'Chơi game',
      Learning_DoHomeWork: 'Làm bài tập',

      System_Profile: 'Quản lý hồ sơ',
      System_Account: 'Quản lý tài khoản',
      System_ChangePassword: 'Đổi mật khẩu',
      System_ActivityLog: 'Nhật ký hoạt động',

      DocumentTest_List: 'Danh sách bài kiểm tra',
      DocumentTest_Mine: 'Danh sách bài kiểm tra của tôi',
      DocumentTest_AssignComposing: 'Danh sách phân công soạn',
      DocumentTest_DotAssignment: 'Danh sách phân công chấm',
      DocumentTest_AddExam: 'Tạo bài kiểm tra',
      DocumentTest_UpdateExam: 'Cập nhật bài kiểm tra',
      DocumentTest_Detail: 'Chi tiết bài kiểm tra',

      ExamSubject_List: 'Danh sách đề thi của giáo viên',
      ExamSubject_Detail: 'Chi tiết đề kiểm tra',

      Practice_List: 'Học liệu của tôi',
      Practice_Detail: 'Xem chi tiết bài ôn luyện',
      Practice_Refer: 'Học liệu tham khảo',
      Practice_Detail_HocMaiCourse: 'Chi tiết khóa học Học mãi',
      Practice_Detail_HocMaiCourseDetail: 'Chi tiết bài giảng Học mãi',
      Practice_Detail_IGiaoDucCourse: 'Chi tiết khóa học Học liệu số BDG',
      Practice_Detail_IGiaoDucCourseDetail: 'Chi tiết bài giảng Học liệu số BDG',
      Practice_Detail_EMIS: 'Chi tiết khóa học Cộng đồng giáo viên',

      RoomEMIS_Meetings: 'Lịch học',
      RoomEMIS_Schedule: 'Thời khóa biểu',

      SelfLearning_List: 'Danh sách tổng quan tự học',
      SelfLearning_Discover: 'Học liệu khám phá',
      SelfLearning_Studying: 'Học liệu đang học',
      SelfLearning_Care: 'Học liệu quan tâm',
      SelfLearning_ListKnowledge: 'Danh sách củng cố kiến thức',
      SelfLearning_ListPractice: 'Danh sách học liệu luyện tập',
      SelfLearning_ListSubject: 'Danh sách môn học',

      RoomEMIS_SetUpClassroom: 'Thiết lập phòng học',
      RoomEMIS_ManageCalendar: 'Quản lý lịch',
      RoomEMIS_CalendarList: 'Danh sách lịch',

      AssessmentPeriod_List: 'Danh sách kỳ đánh giá',
      AssessmentPeriod_ListMarking: 'Danh sách tình trạng chấm bài',
      AssessmentPeriod_ExportExam: 'Xuất khẩu kỳ kiểm tra',
      AssessmentPeriod_ListOverview: 'Danh sách tổng quan của kỳ đánh giá',
      AssessmentPeriod_OpenExam: 'Mở đề bài kiểm tra',
      AssessmentPeriod_AddExamPeriod: 'Tạo kỳ đánh giá',
      AssessmentPeriod_DetailExam: 'Xem chi tiết kỳ đánh giá',
      AssessmentPeriod_DetailExamPeriod: 'Xem chi tiết đề kiểm tra của kỳ đánh giá',
      AssessmentPeriod_MarkAssingment: 'Phân công chấm bài',
      AssessmentPeriod_RoleOrganing: 'Tổ chức kiểm tra bù',
      AssessmentPeriod_GeneralInfo: 'Thông tin chung đề kiểm tra',
      AssessmentPeriod_Monitor: 'Danh sách giám sát học sinh kiểm tra',
      AssessmentPeriod_Statistics: 'Thống kê học sinh tham gia kiểm tra',

      RoomEMIS_SettingClass: 'Thiết lập phòng học',
      RoomEMIS_Book: 'Tạo lịch học',
      Exam_Mine: 'Đề thi của tôi',
      Exam_ShareSchool: 'Đề thi chia sẻ trong trường',
      Exam_Council: 'Hội đồng phân công',
      Exam_List_Share: 'Danh bài kiểm tra chia sẻ',
      Exam_ComposePost: 'Soạn đề kiểm tra'

    }

  }
}

export default Analytics
